import React from 'react';
import { useLocation } from 'react-router-dom';
import PaymentResult from './PaymentResult/index';
import { createDynamicPaymentProps } from 'utils/servicePaymentUtils';

const GenericPaymentSuccess: React.FC = () => {
  const location = useLocation();
  
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Component rendering');
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Current pathname:', location.pathname);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Location state:', location.state);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - URL search params:', location.search);
  
  const props = createDynamicPaymentProps(location.pathname, 'success');
  
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Generated props from createDynamicPaymentProps:', props);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Payment status:', props.paymentStatus);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Service name:', props.serviceName);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Provider name:', props.providerName);
  console.log('[PAYMENT_DEBUG] GenericPaymentSuccess - Service identifier:', props.serviceIdentifier);
  
  return <PaymentResult {...props} />;
};

export default GenericPaymentSuccess;